import React from 'react';
import Seo from '../components/Seo';
import TechnologiesSection from '../components/TechnologiesSection';
import CtaSection from '../components/CtaSection';
import { useLanguage } from '../contexts/LanguageContext';

const TechnologiesPage: React.FC = () => {
  const { translations } = useLanguage();

  return (
    <main className="pt-20 lg:pt-32">
      <Seo pageKey="technologies" />
      <div className="bg-navy text-white py-20">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{translations.technologies.title}</h1>
          <p className="text-xl">{translations.technologies.intro}</p>
        </div>
      </div>
      <TechnologiesSection />
      <CtaSection />
    </main>
  );
};

export default TechnologiesPage; 